import { FC } from 'react';
import { CellContainer } from '@/_components';
import { CellActionsProps } from './CellActions.types';

export const CellActions: FC<CellActionsProps> = ({ children }) => {
  return (
    <CellContainer width={32} isActions={true}>
      {children}
    </CellContainer>
  );
};
